import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REJECT_CANCEL,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
} from "constants/FormatDataContanst";
import { numberWithCommas } from "helpers/utils";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import { getInvoiceStatus } from "pages/IssueInvoice/helper/functionHelper";
import CompareInvoiceModal from "pages/IssueInvoice/modal/CompareInvoiceModal";
import PDFViewModal from "pages/IssueInvoice/modal/PDFViewModal";
import {
  getRowInvoiceReplaceAdjustInfo,
  issueInvoiceModeList,
  issueInvoicePageViewList,
} from "pages/IssueInvoice/utils";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Badge, Card, CardBody } from "reactstrap";
import {
  getDataLink,
  listIssueInvoice,
  resetDownloadXmlIssueInvoice,
  resetListIssueInvoice,
  resetSetBuStoreHeader,
} from "store/actions";
import {
  SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER_SUCCESS,
} from "store/dashboard/actionTypes";
import {
  DOWNLOAD_XML_ISSUE_INVOICE_FAIL,
  DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";

const ListInvoice = props => {
  const { filterList, pageView, title, titleManger } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["issueInvoice"]);
  const { addToast } = useToasts();

  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);

  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);

  // CompareInvoiceModal
  const [dataCompare, setDataCompare] = useState(null);
  const [modalCompareInvoice, setModalCompareInvoice] = useState(false);
  const toggleCompareInvoiceModal = () =>
    setModalCompareInvoice(!modalCompareInvoice);

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingList,
    errorList,
    list: issueInvoiceList,
    fileDownload,
    fileDownloadName,
    type,
  } = issueInvoice;

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { buStoreHeader, type: typeDashboard } = Dashboard;

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);

  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };

  // Action list chang tenantCode
  const [isCheckChangeStore, setIsCheckChangeStore] = useState(false);
  useEffect(() => {
    if (typeDashboard === SET_BU_STORE_HEADER) {
      setIsCheckChangeStore(true);
    }
    if (typeDashboard === SET_BU_STORE_HEADER_SUCCESS && isCheckChangeStore) {
      issueInvoiceList.params.page = 1;
      issueInvoiceList.params.sizePerPage = 10;
      issueInvoiceList.params.columnFilter = { ...filterList };
      dispatch(listIssueInvoice(issueInvoiceList.params));
      dispatch(resetSetBuStoreHeader());
    }
  }, [typeDashboard]);

  // Action list And Change Language
  useEffect(() => {
    initColumn();
    return () => {
      dispatch(resetListIssueInvoice());
    };
  }, [dispatch, t]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (issueInvoiceList) {
      setColumnsTable(initColumns);
    }

    if (issueInvoiceList.columnsVisibleHaveCode) {
      initColumn();
    }
  }, [issueInvoiceList]);

  // Action Dispatch
  useEffect(() => {}, []);

  // Error Dispatch
  useEffect(() => {
    if (errorList && errorList.message) {
      addToast(errorList.message, {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetListIssueInvoice());
    }
  }, [addToast, dispatch, errorList]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadXmlIssueInvoice());
        break;
      }
      case DOWNLOAD_XML_ISSUE_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadXmlIssueInvoice());
        break;
      default:
        break;
    }
  }, [type]);

  const initColumn = () => {
    if (issueInvoiceList.columnsVisible) {
      for (const item of initColumns) {
        if (issueInvoiceList.columnsVisible[item.dataField] !== undefined) {
          item.hidden = !issueInvoiceList.columnsVisible[item.dataField];
        }
      }
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    // dispatch(setListVATInvoiceHaveCodeColumn(field, value));
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    issueInvoiceList.params.sort = sortField
      ? sortOrder + sortField
      : issueInvoiceList.params.sort;
    issueInvoiceList.params.columnFilter =
      { ...columnFilter, ...filterList } || {};
    issueInvoiceList.params.page = page || 1;
    issueInvoiceList.params.sizePerPage = sizePerPage || 10;
    dispatch(listIssueInvoice(issueInvoiceList.params));
  };

  const onSearchAllHandle = value => {
    issueInvoiceList.params.keywords = value;
    dispatch(listIssueInvoice(issueInvoiceList.params));
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
    switch (modeSet) {
      case issueInvoiceModeList.CREATE_VAT_INVOICE_DETAIL:
      case issueInvoiceModeList.CREATE_SALE_INVOICE_DETAIL:
        issueInvoiceList.params.page = 1;
        issueInvoiceList.params.sizePerPage = 10;
        issueInvoiceList.params.columnFilter = {
          ...issueInvoiceList.params.columnFilter,
          ...filterList,
        };
        dispatch(listIssueInvoice(issueInvoiceList.params));
        break;
      default:
        break;
    }
  };

  const createInvoiceHanler = () => {
    setDataDetail({});
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_SALE_INVOICE_NONE_CODE:
        setMode(issueInvoiceModeList.CREATE_SALE_INVOICE_DETAIL);
        break;
      case issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE:
        setMode(issueInvoiceModeList.CREATE_VAT_INVOICE_DETAIL);
        break;
      case issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE:
        setMode(issueInvoiceModeList.CREATE_INVOICE_TICKETS_DETAIL);
        break;
      default:
        break;
    }
    toggleDetailModal();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail({ userId: row.id });
      switch (pageView) {
        case issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE:
        case issueInvoicePageViewList.PAGE_SALE_INVOICE_NONE_CODE:
          setMode(issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL);
          break;
        case issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE:
        case issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE:
          setMode(issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL);
          break;
        case issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE:
        case issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE:
          setMode(issueInvoiceModeList.VIEW_INVOICE_TICKETS_DETAIL);
          break;
        default:
          break;
      }
      toggleDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      text: "Xem trước bản hiển thị",
      onClick: row => {
        showPdfById(row.id);
      },
    },
  ];

  const listMultipleRowAction = [];

  const getSelectFilterAuthStatus = () => {
    let listStatusFilter = [
      AUTH_STATUS_NEW,
      AUTH_STATUS_APPROVE,
      AUTH_STATUS_PROGRESSING,
      AUTH_STATUS_REJECT,
      AUTH_STATUS_CANCEL_WAITING,
      AUTH_STATUS_REJECT_CANCEL,
      AUTH_STATUS_CANCEL,
      AUTH_STATUS_AR,
      AUTH_STATUS_RR,
    ];
    const filter = {};
    for (const item of listStatusFilter) {
      if (selectFilterAuthStatus[item]) {
        filter[item] = selectFilterAuthStatus[item];
      }
    }
    return filter;
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    // [AUTH_STATUS_REPLACE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REPLACE]?.text, // "Thay thế",
    // [AUTH_STATUS_EDIT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_EDIT]?.text, // "Điều chỉnh",
    [AUTH_STATUS_CANCEL_WAITING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL_WAITING]?.text, // "Chờ duyệt hủy",
    [AUTH_STATUS_REJECT_CANCEL]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT_CANCEL]?.text, // "Từ chối hủy",
    [AUTH_STATUS_CANCEL]: commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL]?.text, // "Hủy",

    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    // [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    // [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const getAuthStatus = row => {
    let status = row.auth_status;
    let process_status = row.process_status;
    let id = row.id;
    let child = row.child;
    let root = row.root;
    let infoError = null;
    let progressDiv = null;
    let info = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    if (status === AUTH_STATUS_APPROVE) {
      progressDiv = (
        <div className="d-flex gap-1 mt-2">
          <Badge
            className={`font-size-12 ${commonStatus?.PROGRESS_STATUS[process_status]?.badgeColor}`}
            pill
          >
            {commonStatus?.PROGRESS_STATUS[process_status]?.text}
          </Badge>
        </div>
      );
    }
    info = getRowInvoiceReplaceAdjustInfo(
      row,
      setDataCompare,
      dispatch,
      getDataLink,
      toggleCompareInvoiceModal
    );
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            style={{ width: "110px", whiteSpace: "initial" }}
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>

          {infoError}
          {info}
        </div>
        {/* {progressDiv} */}
      </React.Fragment>
    );
  };

  const initColumns = [
    {
      dataField: "nmua_ten",
      text: "Tên khách hàng",
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      formatter: (cell, row) => {
        return (
          <div style={{ maxWidth: "300px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row),
      //   filter: selectFilter({
      //     placeholder: t("placeholder.select"),
      //     options: getSelectFilterAuthStatus(),
      //     style: { maxWidth: "129px" },
      //   }),
    },
    {
      dataField: "ttchung_khhdon",
      text: t("table.invoice_symbol"),
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      formatter: (cellContent, row) =>
        row.ttchung_khmshdon + row.ttchung_khhdon,
    },
    {
      dataField: "ttchung_shdon",
      text: t("table.invoice_number"),
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      formatter: (cellContent, row) => {
        return cellContent !== "0" && cellContent ? cellContent : "Chờ cấp số";
      },
    },
    {
      dataField: "ttoan_tgtttbso",
      text: "Tổng tiền",
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      formatter: (cell, row) => {
        return numberWithCommas(cell);
      },
    },
    {
      dataField: "ttchung_nlap",
      text: t("table.date_created"),
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.ttchung_nlap),
      //   filter: customFilter({
      //     type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      //   }),
      //   filterRenderer: (onFilter, column) => (
      //     <CustomDateFilter
      //       onFilter={onFilter}
      //       column={column}
      //       paramFilter={issueInvoiceList.params.columnFilter}
      //     />
      //   ),
    },
  ];

  return (
    <React.Fragment>
      {/* ErrorReleaseModal */}
      <ErrorReleaseModal
        isOpen={modalErrorRelease}
        toggle={toggleErrorReleaseModal}
        id={idRelease}
        path={"invoices"}
      />
      {/* PDFViewModal */}
      <PDFViewModal
        isOpen={modalPdfView}
        dataViewDocument={dataViewDocument}
        toggle={togglePdfViewModal}
      ></PDFViewModal>
      <CompareInvoiceModal
        setDataCompare={setDataCompare}
        showPdfById={showPdfById}
        dataCompare={dataCompare}
        isOpen={modalCompareInvoice}
        toggle={toggleCompareInvoiceModal}
      />
      <Card>
        <CardBody>
          <h4 className="card-title mb-4  text-primary">
            Danh sách hóa đơn GTGT/BH gần đây{" "}
            {/* {` (${issueInvoiceList.totalCount})`} */}
          </h4>
          <RemoteDataTable
            // selectRow={selectRowCheckbox}
            // onRowsSelect={onRowsSelect}
            // expandRow={expandRowTable}
            isShowSearchAll={false}
            keyField="id"
            data={issueInvoiceList.items}
            columns={columnsTable}
            page={issueInvoiceList.params.page}
            sizePerPage={issueInvoiceList.params.sizePerPage}
            totalSize={issueInvoiceList.totalCount}
            onTableChange={handleTableChange}
            onSearchAllHandle={onSearchAllHandle}
            optionShowColumnHandel={optionShowColumnHandler}
            rowEvents={rowEventsHandler}
            listMultipleRowAction={listMultipleRowAction}
            listRowAction={listRowAction}
            loading={loadingList}
            isShowPagination={false}
          >
            {" "}
          </RemoteDataTable>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

ListInvoice.propTypes = {
  filterList: PropTypes.object.isRequired,
  pageView: PropTypes.string.isRequired,
  title: PropTypes.string,
  titleManger: PropTypes.string,
};

ListInvoice.defaultProps = {
  filterList: {},
  pageView: "",
};

export default ListInvoice;
